/**
 * External Dependencies
 */
import barba from '@barba/core';
import 'jquery';
import 'slick-carousel';
import 'js-cookie';
import gsap from 'gsap';
import AOS from 'aos';
import Blazy from 'blazy';
import 'waypoints/lib/noframework.waypoints.js';



/** ------------------------------------------------------------------------------------------------------------------
 * GLOBAL
 ------------------------------------------------------------------------------------------------------------------ */

let bLazy = new Blazy(),
  $body = $('body'),
  $menuToggle = $('.js-menu-toggle'),
  $menuDrawer = $('.main-menu');

// Menu Toggle
function menuToggle() {
  $menuToggle.on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $menuDrawer.toggleClass('active');
    $body.toggleClass('menu-open');
  });
}

// Background grid calculations
let root = document.documentElement;

function calculateSquare(root) {
  let currentWidth = $('main').width();
  let columns = getComputedStyle(root, null).getPropertyValue('--columns');
  let unit = root.style.getPropertyValue('--unit');
  root.style.setProperty('--unit', (Math.round(currentWidth / columns) + 'px'));
  root.style.setProperty('--width', currentWidth + 'px');
}

// Color functions
const colorGreen = '#B9EFA3';
const colorPink = '#F0BAE0';
const colorOrange = '#FF671F';
const colorBlue = '#1F21AB';
const colorPurple = '#7D73F7';
const colorCyan = '#67D2DF';
const colorForest = '#005349';
const colorBeige = '#E2E1C7';
const colorTime = 1;

function setTheColor(col, time) {

  const hex2rgba = (hex, alpha = 1) => {
    const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
  }

  if (col.substr(0,1) == '#') {
    gsap.to("body", { duration: time, "--background": hex2rgba(col, 1) });
  }

  else {
    gsap.to("body", { duration: time, "--background": col });
  }

  if (col == '#1F21AB') {
    $('.banner').addClass('white');
  }
  else {
    $('.banner').removeClass('white');
  }
}


// CURSOR

let $cursor = $('.cursor');

function moveCursor(e) {
  $cursor.addClass('is-moving');
  $cursor.css({"top": e.clientY, "left": e.clientX});

  clearTimeout(timer2);

   var timer2 = setTimeout(function() {
       $cursor.removeClass('is-moving');
   }, 500);
}

$(window).on('mousemove', moveCursor);



$('.grid-layout>.casestudy').on('mouseover', function(){
  $cursor.addClass('go');
})

$('.grid-layout>.casestudy').on('mouseout', function(){
  $cursor.removeClass('go');
})





// $('.careers-image.slick').slick();

// Holds last colour for transitions
let previousColor = getComputedStyle(document.body).getPropertyValue('--background');

function setPreviousColor() {
  previousColor = getComputedStyle(document.body).getPropertyValue('--background');
  //previousColor = col;
  console.log('pre-change color is ' + previousColor);
}

// Marquee scrolling text
function setMarquee(target) {
  let textWidth = $(target + '#div1').width();
  let boxWidth = $(target).width();
  let ratio = Math.round((textWidth / boxWidth) * 10) / 10;
  let speed = 10;
  let loopTime = 60;

  $(target + ' #div1').css("animation", "marquee " + loopTime + "s linear infinite");
  $(target + ' #div2').css("animation", "marquee2 " + loopTime + "s linear infinite");
  $(target + ' #div2').css("animation-delay", "-" + (loopTime / 2) + "s");
}

function setMarqueeVertical(target) {
  let loopTime = 15;
  $(target + ' #div1').css("animation", "marquee-vertical " + loopTime + "s linear infinite");
  $(target + ' #div2').css("animation", "marquee-vertical2  " + loopTime + "s linear infinite");
  $(target + ' #div2').css("animation-delay", "-" + (loopTime / 2) + "s");
}

// Waypoints – Footer
function setFooterWaypoint() {
  let $colorFooter = document.getElementById('js-footer');
  if ($colorFooter && !($('.filter').length)) {
    const wayFooter = new Waypoint({
      element: $colorFooter,
      offset: '80%',
      handler: (direction) => {
        switch (direction) {
          case "down":
            console.log('footer down');
            setPreviousColor();
            console.log('previous color = ' + previousColor);
            setTheColor(colorBlue, colorTime);
            break;
          case "up":
            console.log('footer up');
            setTheColor(previousColor, colorTime);
            break;
        }
      },
    });
  }
}

/** ------------------------------------------------------------------------------------------------------------------
 * Page: Home
 ------------------------------------------------------------------------------------------------------------------ */

function routeHome() {

  var dataText = ["We build brands that enhance human potential."];
  function typeWriter(text, i, fnCallback) {
    if (i < (text.length)) {
      document.querySelector(".type-me").innerHTML = text.substring(0, i+1) +'<span class="typewriter" aria-hidden="true"></span>';
      setTimeout(function() {
        typeWriter(text, i + 1, fnCallback)
      }, 85);
    }
    else if (typeof fnCallback == 'function') {
      setTimeout(fnCallback, 700);
    }
  }

  function StartTextAnimation(i) {
      if (typeof dataText[i] == 'undefined'){
        setTimeout(function() {
          StartTextAnimation(0);
        }, 200000);
      }
    if (i < dataText[i].length) {
      typeWriter(dataText[i], 0, function(){
        StartTextAnimation(i + 1);
      });
    }
  }
  StartTextAnimation(0);

  // Newsletter modal
  function NewsletterModal() {
    $('.home .newsletter-modal-container').addClass('active');
    $('.home .newsletter-modal-container .menu-close-green').on('click', function(){
        $('.home .newsletter-modal-container').removeClass('active');
    })
  }
  setTimeout(NewsletterModal, 6000);

  // Folio
  $('.folio-mask').on('mouseover', function () {
    $('.folio-mask').removeClass('active');
    $(this).addClass('active');
  })

  // Resetting Menu active classes WP

  $('.current-menu-item').removeClass('current-menu-item');
  $('.menu-item-home').addClass('current-menu-item');

  // Waypoints

  let el = document.getElementById('js-home-1');
  if (el) {
    console.log("js-home-1")
    const wayFooter = new Waypoint({
      element: el,
      offset: '80%',
      handler: (direction) => {
        switch (direction) {
          case "down":
            setTheColor(colorBeige, colorTime);
            console.log('home.down');
            break;
          case "up":
            setTheColor(colorGreen, colorTime);
            console.log('home.up');
            break;
        }
      },
    })
  }

  let el2 = document.getElementById('js-home-2');
  if (el2) {
    console.log("js-home-2")
    const wayFooter = new Waypoint({
      element: el2,
      offset: '80%',
      handler: (direction) => {
        switch (direction) {
          case "down":
            setTheColor(colorBlue, colorTime);
            console.log('home.down');
            break;
          case "up":
            setTheColor(colorBeige, colorTime);
            console.log('home.up');
            break;
        }
      },
    })
  }
}


/** ------------------------------------------------------------------------------------------------------------------
 * Page: Profile
 ------------------------------------------------------------------------------------------------------------------ */
function routeProfile() {

  let el = document.getElementById('js-profile-color-1');
  if (el) {
    console.log("js-profile-color-1")
    const wayFooter = new Waypoint({
      element: el,
      offset: '80%',
      enabled: false,
      handler: (direction) => {
        switch (direction) {
          case "down":
            setTheColor(colorGreen, colorTime);
            console.log('profile1.down');
            break;
          case "up":
            setTheColor(colorPink, colorTime);
            console.log('profile1.up');
            break;
        }
      },
    })
  }

  let profileTrigger1 = document.getElementById('profile-trigger-1');
  if (profileTrigger1) {
    const waypointP1 = new Waypoint({
      element: profileTrigger1,
      offset: '90%',
      enabled: false,
      handler: (direction) => {
        switch (direction) {
          case "down":
            $('.cta-ball').addClass('active');
            break;
          case "up":
            break;
        }
      },
    });
  }

  let profileTrigger2 = document.getElementById('profile-trigger-2');
  if (profileTrigger2) {
    const waypointP2 = new Waypoint({
      element: profileTrigger2,
      offset: '40%',
      enabled: false,
      handler: (direction) => {
        switch (direction) {
          case "down":
            $('.what-we-do').slick('slickGoTo', 2);
            break;
          case "up":
            $('.what-we-do').slick('slickGoTo', 1);
            break;
        }
      },
    });
  }

  // What we do Slick

  // Staff
  $('.sidebar-toggle').on('click', function (e) {
    e.preventDefault();
    var num = $(this).data('toggle');
    $('.sidebar-content').addClass('hidden');
    $('.sidebar *[data-index="' + num + '"]').removeClass('hidden');
    $('.sidebar').addClass('active');
  });

  $('.sidebar .close').on('click', function (e) {
    e.preventDefault();
    $('.sidebar').removeClass('active');
  });

  $('.slide-1').slick({
    fade: true,
    waitForAnimate: false,
    arrows: false,
    //variableWidth: true,
    autoplay: true,
    autoplaySpeed: 3000,
  });

  $('.slide-2').slick({
    fade: true,
    waitForAnimate: false,
    arrows: false,
    //variableWidth: true,
    autoplay: true,
    autoplaySpeed: 3000,
  });

  // $('#goto-profile-work').on('click', function(e){
  //   $([document.documentElement, document.body]).animate({
  //       scrollTop: $(".careers-positions").offset().top - 145
  //   }, 1000);
  // })

  function accordionHandler(e) {
    console.log('handler');
    console.log(e);
    $(e).parent().toggleClass("open");
    let panel = $(e).next()[0]; // that goddamn jquery object > native DOM element
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 30 + "px";
    }
  }

  var acc = document.getElementsByClassName("accordion-item-title");
  var i;

  for (i = 0; i < acc.length; i++) {
    // acc[i].addEventListener("click", accordionHandler, false);
    $(acc[i]).on('click', function () {
      accordionHandler(this);
    })
  }

  $('.marquee-about').slick({
    fade: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    pauseOnHover: false,
    cssEase: 'linear',
    autoplaySpeed: 0,
    speed: 3000,
    //cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)', // quart
    //cssEase: 'cubic-bezier(0.860, 0.000, 0.070, 1.000)', // quint
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 4,
          vertical: true,
        },
      },
    ],
  });

  $('.guiding-words').slick({
    fade: true,
    arrows: false,
  });

  // Guiding Principles carousel
  function guidingPrinciples() {
    $('.guiding-numbers li').on('click', function () {
      var i = $(this).index();
      $('.guiding-numbers li').removeClass('active');
      $(this).addClass('active');
      $('.guiding-words').slick('slickGoTo', i);
    })
    $('.guiding-numbers li').first().addClass('active');
  }

  return {
    guidingPrinciples: guidingPrinciples
  };

}

/** ------------------------------------------------------------------------------------------------------------------
 * Page: Work
 ------------------------------------------------------------------------------------------------------------------ */
function routeWork() {

  var size = $(".work-recent-work .work-layout").size();
  $('.work-recent-work .work-layout').hide();
  var x = 1;
  $('.work-recent-work .work-layout').first().show();

  $('#loadmore').on('click', function () {
    x = (x + 1 <= size) ? x + 1 : size;
    $('.work-recent-work .work-layout:lt(' + x + ')').show();

    if(x >= size) {
      $('#loadmore').hide();
    }
  });

  $('.work-recent-work .alm-load-more-btn').show();

  let el = document.getElementById('js-work-color-1');
  if (el) {
    console.log("js-profile-color-1")
    const wayFooter = new Waypoint({
      element: el,
      offset: '50%',
      handler: (direction) => {
        switch (direction) {
          case "down":
            setTheColor(colorForest, colorTime);
            console.log('work.down');
            break;
          case "up":
            setTheColor(colorGreen, colorTime);
            console.log('work.up');
            break;
        }
      },
    })
  }

  // let workTrigger1 = document.getElementById('work-trigger-1');
  // if (workTrigger1) {
  //   const waypointW1 = new Waypoint({
  //     element: workTrigger1,
  //     offset: '40%',
  //     handler: (direction) => {
  //       switch (direction) {
  //         case "down":
  //           $('.work-slides').slick('slickGoTo', 1);
  //           $('.work-intro-image').slick('slickGoTo', 1);
  //           console.log(workTrigger1.id + ' hit from direction: ', direction);
  //           break;
  //         case "up":
  //           $('.work-slides').slick('slickGoTo', 0);
  //           $('.work-intro-image').slick('slickGoTo', 0);
  //           console.log(workTrigger1.id + ' hit from direction: ', direction);
  //           break;
  //       }
  //     },
  //   });
  // }

  // let workTrigger2 = document.getElementById('work-trigger-2');
  // if (workTrigger2) {
  //   const waypointW2 = new Waypoint({
  //     element: workTrigger2,
  //     offset: '50%',
  //     handler: (direction) => {
  //       switch (direction) {
  //         case "down":
  //           $('.work-slides').slick('slickGoTo', 2);
  //           $('.work-intro-image').slick('slickGoTo', 2);
  //           break;
  //         case "up":
  //           $('.work-slides').slick('slickGoTo', 1);
  //           $('.work-intro-image').slick('slickGoTo', 1);
  //           break;
  //       }
  //     },
  //   });
  // }

  // let workTrigger3 = document.getElementById('work-trigger-3');
  // if (workTrigger3) {
  //   const waypointW3 = new Waypoint({
  //     element: workTrigger3,
  //     offset: '50%',
  //     handler: (direction) => {
  //       switch (direction) {
  //         case "down":
  //           $('.work-slides').slick('slickGoTo', 3);
  //           $('.work-intro-image').slick('slickGoTo', 3);
  //           break;
  //         case "up":
  //           $('.work-slides').slick('slickGoTo', 2);
  //           $('.work-intro-image').slick('slickGoTo', 2);
  //           break;
  //       }
  //     },
  //   });
  // }

  function accordionHandler(e) {
    $(e).parent().toggleClass("open");
    let panel = $(e).next()[0]; // that goddamn jquery object > native DOM element
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 30 + "px";
    }
  }

  var acc = document.getElementsByClassName("accordion-item-title");
  var i;

  for (i = 0; i < acc.length; i++) {
    // acc[i].addEventListener("click", accordionHandler, false);
    $(acc[i]).on('click', function () {
      accordionHandler(this);
    })
  }

  $('.logos').slick({
    fade: false,
    infinite: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
    pauseOnHover: false,
    speed: 900,
    cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)', // quart
    //cssEase: 'cubic-bezier(0.860, 0.000, 0.070, 1.000)', // quint
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });

//   $('.work .casestudy').on('mouseover', function () {
//
//     setTheColor(colorForest, .2);
//   })
//   $('.work .casestudy').on('mouseout', function () {
//
//     setTheColor(colorBeige, .2);
//   })





  // $('.work-slides').slick({
  //   fade: true,
  //   waitForAnimate: false,
  //   arrows: false,
  // });

  // $('.work-intro-image').slick({
  //   fade: true,
  //   waitForAnimate: false,
  //   arrows: false,
  // });


  // var size = $(".recent-work .featured").size();
  // $('.recent-work .featured').hide();
  // var x = 4;
  // $('.recent-work .featured:lt(' + x + ')').show();
  // $('#loadmore').on('click', function () {
  //   x = (x + 4 <= size) ? x + 4 : size;
  //   $('.recent-work .featured:lt(' + x + ')').show();
  // });

}


/** ------------------------------------------------------------------------------------------------------------------
 * Magazine
 ------------------------------------------------------------------------------------------------------------------ */
function routeMagazine(refContainer) {

  $('.close-filter').on('click', function () {
    $('.filter').removeClass('active');
  })
  $('.show-filter').on('click', function () {
    $('.filter').addClass('active');
  })
  $('.alm-filter--link').on('click', function () {
    $(window).scrollTop(0);
    $('.filter').removeClass('active');
  })
  $('#js-filter-reset').on('click', function () {

    $(window).scrollTop(0);
    $('.filter').removeClass('active');
    almfilters.reset();
  })

  var elem = document.querySelector('.ajax-load-more-wrap');

  window.almOnChange = function(alm){
    console.log("Ajax Load More is loading...");
    setTimeout(function () {
      $('.alm-load-more-btn').show();
    }, 1000);
  };

  console.log('clicking button');
  document.querySelector(".alm-load-more-btn").click();
  setTimeout(function () {
    $('.alm-load-more-btn').show();
  }, 1000);

  function initALM(refContainer) {
    ajaxloadmore.start(elem);
  }

  return {
    initALM: initALM,
  }
}


/** ------------------------------------------------------------------------------------------------------------------
 * Posts
 ------------------------------------------------------------------------------------------------------------------ */


function routePosts(refContainer) {

  function postsWaypoint(refContainer) {
    let el = refContainer.querySelector('#js-posts-color-1');
    if (el) {
      console.log("setting up waypoint");
      const wayPosts = new Waypoint({
        element: el,
        enabled: true,
        offset: '80%',
        handler: (direction) => {
          switch (direction) {
            case "down":
              let theY = $('#js-posts-color-1').offset();
              let scrollPos = $(window).scrollTop();
              console.log('post.down  —  triggerPos = ' + theY.top + '  /  yPos = ' + scrollPos);
              setTheColor(colorBlue, colorTime);
              break;
            case "up":
              setTheColor("#FFFFFF", colorTime);
              console.log('post.up');
              break;
          }
        },
      })
    }
  }

  // Slick to turn Gallery into Sliders for blog posts
  function postsGallery(refContainer) {
    let $gallery = $(refContainer).find('.blocks-gallery-grid');
    if ($gallery.length > 0) {
      // init slick
      $gallery.slick({
        adaptiveHeight: false,
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: true,

      });
    }
  }

  function casesGallery(refContainer) {
    //console.log('refContainer = ' + refContainer);
    let $gallery = $(refContainer).find('section.blocks .slick');
    if ($gallery.length > 0) {

      $gallery.each(function () {
        $(this).slick({
          adaptiveHeight: false,
          slidesToScroll: 1,
          slidesToShow: 1,
          arrows: true,
          customPaging : function(slider, i) {
              var thumb = jQuery(slider.$slides[i]).data();
              return '<a>'+(i+1)+'</a>';
          }

        });
      });
    }
  }

  // temporary helper for available classes
  function casesClassHelper() {
    $('section.blocks > section').each(function () {
      var sectionClasses = $(this).attr("class");
      $(this).append(`<p class="classes-helper">Classes: .${sectionClasses}</p>`);
    });
  }

  return {
    postsGallery: postsGallery,
    casesGallery: casesGallery,
    postsWaypoint: postsWaypoint,
    casesClassHelper: casesClassHelper
  };
}



/** ------------------------------------------------------------------------------------------------------------------
 * Page: Careers
 ------------------------------------------------------------------------------------------------------------------ */
function routeCareers() {

  if (window.location.hash) {
    let hash = window.location.hash.substr(1);
    let hashTarget = $("#" + hash);
    let hashSibling = $(hashTarget).siblings(".accordion-item-title");
    // console.log("1 " + hash);
    // console.log("2 " + hashTarget);
    // console.log("3 " + hashSibling);
    accordionHandler(hashSibling);
    //$(hashSibling).fadeOut("slow");
  }

  $('.careers-image').slick({
    fade: true,
    autoplay: true,
    autoplaySpeed: 1500,
    arrows: false,
  })

  function accordionHandler(e){
    console.log('handler');
    console.log(e);
    $(e).parent().toggleClass("open");
    let panel = $(e).next()[0]; // that goddamn jquery object > native DOM element
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 30 + "px";
    }
  }

  $("#js-careers-but-openings").on("click", function(){
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".careers-positions").offset().top - 145
    }, 1000);
  })

  // window.addEventListener("load", function(){

    // accordions

    var acc = document.getElementsByClassName("accordion-item-title");
    var i;

    for (i = 0; i < acc.length; i++) {
      // acc[i].addEventListener("click", accordionHandler, false);
      $(acc[i]).on('click', function(){
        accordionHandler(this);
      })
    }

    // color changes

    let careersTrigger1 = document.getElementById('js-careers-color-1');
    if (careersTrigger1) {
      console.log("js-careers-color-1")
      const wayCareers1 = new Waypoint({
        element: careersTrigger1,
        offset: '50%',
        handler: (direction) => {
          switch (direction) {
            case "down":
              setTheColor(colorCyan, colorTime);
              console.log('careers 1 down to Cyan');
              break;
            case "up":
              setTheColor(colorPurple, colorTime);
              console.log('careers 1 up to Purple');
              break;
          }
        },
      })
    }

    let careersTrigger2 = document.getElementById('js-careers-color-2');
    if (careersTrigger2) {
      console.log("js-careers-color-2")
      const wayCareers2 = new Waypoint({
        element: careersTrigger2,
        offset: '50%',
        handler: (direction) => {
          switch (direction) {
            case "down":
              setTheColor(colorForest, colorTime);
              console.log('careers 2 down to Forest');
              break;
            case "up":
              setTheColor(colorCyan, colorTime);
              console.log('careers 2 up to Cyan');
              break;
          }
        },
      })
    }

  // })



}


/** ------------------------------------------------------------------------------------------------------------------
 * BARBA
 ------------------------------------------------------------------------------------------------------------------ */

barba.init({
  debug: true,
  timeout: 8000,
  views: [
    {
      namespace: 'Home',
      once() {
        setTheColor(colorGreen, colorTime);
        routeGlobal();
        routeHome();
      },
      afterEnter() {
        setTheColor(colorGreen, colorTime);
        routeGlobal();
        routeHome();
      },
    },
    {
      namespace: 'About',
      once() {
        setTheColor(colorPink, colorTime);
      },
      afterEnter() {
        setTheColor(colorPink, colorTime);
        routeGlobal();
        //routeProfile();
        let refProfile = routeProfile();
        refProfile.guidingPrinciples();
        Waypoint.refreshAll();
        Waypoint.enableAll();
      },
    },
    {
      namespace: 'Work',
      once() {
        $('.logos').slick();
        setTheColor(colorGreen, colorTime);
      },
      afterEnter() {
        setTheColor(colorGreen, colorTime);
        routeGlobal();
        routeWork();
      },
    },
    {
      namespace: 'Careers',
      once() {
        //$('.logos').slick();
        setTheColor(colorPurple, colorTime);
      },
      afterEnter() {
        setTheColor(colorPurple, colorTime);
        routeGlobal();
        routeCareers();
      },
    },
    {
      namespace: 'Blog',
      once() {
      },
      beforeEnter(data) {
      },
      afterEnter(data) {
        let refContainer = data.next.container;
        setTheColor(colorBeige, colorTime);
        routeGlobal();

        let refMagazine = routeMagazine();
        if (data.current.url.href) {
          refMagazine.initALM(refContainer);
          document.querySelector(".alm-load-more-btn").click();


          // document.querySelector(".alm-btn-wrap").style.display = 'block';
        }

        var el = document.querySelector('.ajax-load-more-wrap');
        // eslint-disable-next-line
        //ajaxloadmore.start(el);

        var el_filter = document.querySelector('.alm-filters');
        // eslint-disable-next-line
        almfilters.start(el_filter);

        setTimeout(function () {
          $('.alm-load-more-btn').show();
        }, 1000);
      },
    },
    {
      namespace: 'Post',
      once() {
      },
      afterEnter(data) {
        let refContainer = data.next.container;
        setTheColor('#FFFFFF', colorTime);
        let refPosts = routePosts();
        refPosts.postsWaypoint(refContainer);
        refPosts.postsGallery(refContainer);
        //refPosts.casesGallery();
        //refPosts.casesClassHelper();
        routeGlobal();
      },
    },
    {
      namespace: 'Case Study',
      once() {
      },
      afterEnter(data) {
        // console.log('------------------------------------ entering new page');
        let refContainer = data.next.container;
        setTheColor('#FFFFFF', colorTime);
        let refPosts = routePosts();
        refPosts.postsWaypoint(refContainer);
        //refPosts.postsGallery();
        refPosts.casesGallery(refContainer);
        //refPosts.casesClassHelper();
        routeGlobal();
      },
    },
  ],
  transitions: [
    {
      name: 'basic',
      sync: true,
      once() {
        menuToggle();
      },
      before() {
        Waypoint.destroyAll();
        console.log("> Destroying waypoints");
      },
      leave: function (data) {
        // close menu
        if ($body.hasClass('menu-open')) {
          $body.removeClass('menu-open');
          $menuToggle.removeClass('active');
          $menuDrawer.removeClass('active');
        };

      },
      afterEnter: function (data) {
        $(window).scrollTop(0);
      },
      after(data) {
        // add barba classes to body
        $('body').attr('class', $('#body-classes').attr('class'));
        AOS.refresh();

        function refreshWaypoints() {
          Waypoint.refreshAll();
          console.log('> refreshed waypoints');
        }
        function enableWaypoints() {
          Waypoint.enableAll();
          console.log('> enabled waypoints');
        }
        setFooterWaypoint();
        enableWaypoints();

        // Update the active menu item classes
        if ( data.next.url.path ) {
          const activeClass = 'current-menu-item';

          $( '.menu-item.' + activeClass ).each( function() {
            $(this).removeClass(activeClass);
          });
          $(`.menu-item > a[href$="${ data.next.url.path }"]`).closest('.menu-item').each( function() {
            $(this).addClass(activeClass);
          });
        }
      },
    },
  ],
  prevent: ({ el }) => el.classList && el.classList.contains('prevent'),
});

/** ------------------------------------------------------------------------------------------------------------------
 * Init / Resize / Load
 ------------------------------------------------------------------------------------------------------------------ */

function routeGlobal() {
  calculateSquare(root);
  setMarquee('.marquee');
  setMarqueeVertical('.marquee-vertical');
  AOS.init();
  $cursor.removeClass('go');
  //setFooterWaypoint();

  $('.cta-form').on('click', function(e){
    e.preventDefault();
    $('.contact-form-wrapper').addClass('active');
  })
  $('.contact-form-close').on('click', function(){
    $('.contact-form-wrapper').removeClass('active');
  })
}

// init
routeGlobal();

// Window resize
$(window).resize(function () {
  calculateSquare(root);
});

// Window load
$(window).on('load', function () {
  AOS.refresh();
  $cursor.removeClass('go');
});
